/**
 * Ready2Book design system colour utility class names.
 * Pairs with `src/styles/_r2b-colour-utilities.scss`.
 *
 * Legacy Vuetify-oriented colour classes remain in VuetifyColourClass.js.
 */
export default Object.freeze({
  brandBlue: 'brand-blue',
  brandBlue25: 'brand-blue-25',
  brandBlue100: 'brand-blue-100',
  brandBlue200: 'brand-blue-200',
  brandBlue300: 'brand-blue-300',
  brandBlue400: 'brand-blue-400',
  brandBlue500: 'brand-blue-500',
  brandBlue600: 'brand-blue-600',
  brandBlue700: 'brand-blue-700',
  brandPurple100: 'brand-purple-100',
  brandPurple200: 'brand-purple-200',
  brandPurple300: 'brand-purple-300',
  brandPurple400: 'brand-purple-400',
  brandPurple500: 'brand-purple-500',
  brandPurple600: 'brand-purple-600',
  brandGreen100: 'brand-green-100',
  brandGreen200: 'brand-green-200',
  brandGreen300: 'brand-green-300',
  brandGreen400: 'brand-green-400',
  brandGreen500: 'brand-green-500',
  brandGreen600: 'brand-green-600',
  brandYellow100: 'brand-yellow-100',
  brandYellow200: 'brand-yellow-200',
  brandYellow300: 'brand-yellow-300',
  brandYellow400: 'brand-yellow-400',
  brandYellow500: 'brand-yellow-500',
  brandYellow600: 'brand-yellow-600',
  semanticsError100: 'semantics-error-100',
  semanticsError200: 'semantics-error-200',
  semanticsError300: 'semantics-error-300',
  semanticsError400: 'semantics-error-400',
  semanticsError500: 'semantics-error-500',
  semanticsWarning100: 'semantics-warning-100',
  semanticsWarning200: 'semantics-warning-200',
  semanticsWarning300: 'semantics-warning-300',
  semanticsWarning400: 'semantics-warning-400',
  semanticsWarning500: 'semantics-warning-500',
  semanticsSuccess100: 'semantics-success-100',
  semanticsSuccess200: 'semantics-success-200',
  semanticsSuccess300: 'semantics-success-300',
  semanticsSuccess400: 'semantics-success-400',
  semanticsSuccess500: 'semantics-success-500',
  neutralsGrey50: 'neutrals-grey-50',
  neutralsGrey100: 'neutrals-grey-100',
  neutralsGrey200: 'neutrals-grey-200',
  neutralsGrey300: 'neutrals-grey-300',
  neutralsGrey400: 'neutrals-grey-400',
  neutralsGrey500: 'neutrals-grey-500',
  neutralsWhite: 'neutrals-black-and-white-white',
  neutralsBlack: 'neutrals-black-and-white-black',

  text: Object.freeze({
    brandBlue: 'brand-blue-text',
    brandBlue100: 'brand-blue-100-text',
    brandBlue200: 'brand-blue-200-text',
    brandBlue300: 'brand-blue-300-text',
    brandBlue400: 'brand-blue-400-text',
    brandBlue500: 'brand-blue-500-text',
    brandBlue600: 'brand-blue-600-text',
    brandBlue700: 'brand-blue-700-text',
    brandPurple100: 'brand-purple-100-text',
    brandPurple200: 'brand-purple-200-text',
    brandPurple300: 'brand-purple-300-text',
    brandPurple400: 'brand-purple-400-text',
    brandPurple500: 'brand-purple-500-text',
    brandPurple600: 'brand-purple-600-text',
    brandGreen100: 'brand-green-100-text',
    brandGreen200: 'brand-green-200-text',
    brandGreen300: 'brand-green-300-text',
    brandGreen400: 'brand-green-400-text',
    brandGreen500: 'brand-green-500-text',
    brandGreen600: 'brand-green-600-text',
    brandYellow100: 'brand-yellow-100-text',
    brandYellow200: 'brand-yellow-200-text',
    brandYellow300: 'brand-yellow-300-text',
    brandYellow400: 'brand-yellow-400-text',
    brandYellow500: 'brand-yellow-500-text',
    brandYellow600: 'brand-yellow-600-text',
    semanticsError100: 'semantics-error-100-text',
    semanticsError200: 'semantics-error-200-text',
    semanticsError300: 'semantics-error-300-text',
    semanticsError400: 'semantics-error-400-text',
    semanticsError500: 'semantics-error-500-text',
    semanticsWarning100: 'semantics-warning-100-text',
    semanticsWarning200: 'semantics-warning-200-text',
    semanticsWarning300: 'semantics-warning-300-text',
    semanticsWarning400: 'semantics-warning-400-text',
    semanticsWarning500: 'semantics-warning-500-text',
    semanticsSuccess100: 'semantics-success-100-text',
    semanticsSuccess200: 'semantics-success-200-text',
    semanticsSuccess300: 'semantics-success-300-text',
    semanticsSuccess400: 'semantics-success-400-text',
    semanticsSuccess500: 'semantics-success-500-text',
    neutralsGrey50: 'neutrals-grey-50-text',
    neutralsGrey100: 'neutrals-grey-100-text',
    neutralsGrey200: 'neutrals-grey-200-text',
    neutralsGrey300: 'neutrals-grey-300-text',
    neutralsGrey400: 'neutrals-grey-400-text',
    neutralsGrey500: 'neutrals-grey-500-text',
    neutralsWhite: 'neutrals-black-and-white-white-text',
    neutralsBlack: 'neutrals-black-and-white-black-text',
  }),
})
